// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Breadcrumbs from '@/components/breadcrumbs';
import Tabs from '@/components/tabs';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Attachments from '@/components/shared-views/attachments';
import Communications from '@/components/shared-views/communications';
import ProductDetails from '@/components/product/details';
import TransferOwnership from '@/components/modals/asset/transfer-ownership';
import ToastContext from '@/utils/toast-context';
import ConfirmAction from '@/components/modals/confirm-action';
import OptionService from '@/services/option/option-service';
import Storage from '@/utils/storage';
import Router, { useRouter } from 'next/router';
import AssetService from '@/services/asset/asset-service';
import WarrantyIndicator from '@/components/product/warranty-indicator';
import {Box, Card, Flex} from "@mantine/core";
import ToolbarButtons from "@/PageComponents/Button/ToolbarButtons";
import {useElementSize} from "@mantine/hooks";
import {IconArrowBackUp, IconDeviceFloppy, IconSquareCheckFilled} from "@tabler/icons-react";
import {IconDotsVertical, IconSquareCheck} from "@tabler/icons";
import AssetJobsTable from "@/PageComponents/Table/Component Tables/AssetJobsTable";
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function ProductPage() {

  const router = useRouter();
  const { id, tab } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const toast = useContext(ToastContext);

  const { data: productData } = useQuery(
    ['product', id],
    () => Fetch.get({ url: '/Product', params: { id } }),
    { enabled: !!id }
  );

  const { data: customerData } = useQuery(
    ['customer', productData?.CustomerID],
    () => Fetch.get({ url: `/Customer/${productData.CustomerID}` }),
    { enabled: !!productData?.CustomerID }
  );

  const { data: customFieldsData } = useQuery(
    ['customFields', Enums.Module.Asset],
    () => OptionService.getCustomFields(Enums.Module.Asset)
  );

  const customFields = customFieldsData ?? [];

  const [pageTabs, setPageTabs] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState<any>(null);

  const [attachmentCount, setAttachmentCount] = useState(0);
  const [communicationCount, setCommunicationCount] = useState(0);
  const [jobCount, setJobCount] = useState(0);
  const [countsToggle, setCountsToggle] = useState(false);

  const getCounts = async (productId: any) => {
    let counts = await AssetService.getCounts(productId);
    setAttachmentCount(counts.attachmentCount);
    setCommunicationCount(counts.communicationCount);
    setJobCount(counts.jobCount);
    setCountsToggle((x: any) => !x);
  };

  const buildUpPageTabs = () => {
    let tabs = [
      { text: 'Asset' },
      { text: 'Attachments', count: attachmentCount },
      { text: 'Messages', count: communicationCount },
      { text: 'Jobs', count: jobCount },
    ];
    setPageTabs(tabs);
  };

  useEffect(() => {
    buildUpPageTabs();
  }, [countsToggle]);

  const [customer, setCustomer] = useState<any>(null);
  const [contacts, setContacts] = useState<any[]>([]);
  const [contact, setContact] = useState<any>(null);
  const [locations, setLocations] = useState<any[]>([]);
  const [location, setLocation] = useState<any>(null);
  const [product, setProduct] = useState<any>(null);

  useEffect(() => {
    setProduct(null);
    setCustomer(null);
    setContacts([]);
    setContact(null);
    setLocations([]);
    setLocation(null);
    setSelectedTab(null);
  }, [id]);

  useEffect(() => {
    if (productData && !product) {
      setProduct(productData);
      setContact(productData.Contact);
      setLocation(productData.Location);
      getCounts(productData.ID);
    }
  }, [productData]);

  useEffect(() => {
    if (customerData && !customer) {
      setCustomer(customerData);
      setContacts(customerData.Contacts);
      setLocations(customerData.Locations);
    }
  }, [customerData]);

  useEffect(() => {
    if (selectedTab === null && router.isReady) {
      setSelectedTab(tab === 'communication' ? 'Messages' : 'Asset');
    }
  }, [router.isReady, tab]);

  const [saving, setSaving] = useState(false);
  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveProduct, true);

  const cancel = () => {
    Helper.nextRouter(Router.push, "/customer/list?tab=assets");
  };

  const updateProduct = (field: any, value: any) => {
    let newProductState = { ...product };
    newProductState[field] = value;
    setProduct(newProductState);
    setFormIsDirty(true);
  };

  const updateProductInBulk = (items: any) => {
    let temp = { ...product };
    for (var i = 0; i < items.length; i++) {
      temp[items[i].field] = items[i].value;
    }
    setProduct(temp);
    setFormIsDirty(true);
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {
    let validationItems = [
      { key: 'InventoryID', value: product.InventoryID, required: true, type: Enums.ControlType.Text },
      { key: 'PurchaseDate', value: product.PurchaseDate, required: true, type: Enums.ControlType.Date },
      { key: 'PurchaseAmount', value: product.PurchaseAmount, required: true, type: Enums.ControlType.Number },
    ];

    let { field1Required, field2Required, serialNumberRequired, invoiceNumberRequired, locationRequired } =
      OptionService.getProductCustomFields(customFields);

    if (field1Required) {
      validationItems = [...validationItems,
      { key: 'CustomField1', value: product.CustomField1, required: true, type: Enums.ControlType.Text }];
    }

    if (field2Required) {
      validationItems = [...validationItems,
      { key: 'CustomField2', value: product.CustomField2, required: true, type: Enums.ControlType.Text }];
    }

    if (serialNumberRequired) {
      validationItems = [...validationItems,
      { key: 'SerialNumber', value: product.SerialNumber, required: true, type: Enums.ControlType.Text }];
    }

    if (invoiceNumberRequired) {
      validationItems = [...validationItems,
      { key: 'InvoiceNumber', value: product.InvoiceNumber, required: true, type: Enums.ControlType.Text }];
    }

    if (locationRequired) {
      validationItems = [...validationItems,
      { key: 'Location', value: location, required: true, type: Enums.ControlType.Select }];
    }

    const { isValid, errors } = Helper.validateInputs(validationItems);
    setInputErrors(errors);
    return isValid;
  };

  const [assetFormState, setAssetFormState] = useState({
    inputErrors: {},
    submitState: 'none',
  });

  const [triggerSaveComment, setTriggerSaveComment] = useState(0);
  async function submitComment() {
    setTriggerSaveComment((x: any) => x + 1);
  }

  async function saveProduct(navToRoute: any) {
    setSaving(true);

    await submitComment().then(() => setAssetFormState((p: any) => ({
      ...p,
      submitState: 'onSubmit',
      ...(navToRoute && {navToRoute} || {})
    })));

    setSaving(false);
  }

  useEffect(() => {
    if (assetFormState.submitState === 'loading') {
      setSaving(true);
    } else {
      setSaving(false);
    }

    if (assetFormState.submitState === 'error' && assetFormState.inputErrors) {
      console.error('errors on page');
    }
  }, [assetFormState]);

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  // SCRAPPING

  const [toggling, setToggling] = useState(false);

  async function toggleScrapping() {
    setToggling(true);

    const productScrapToggle = await Fetch.get({
      url: `/Product/ProductScrapToggle?id=${product.ID}&isScrapped=${!product.IsScrapped}`,
      toastCtx: toast
    });

    if (productScrapToggle.ID) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const productScrapToggleInner = await Fetch.get({
            url: `/Product/ProductScrapToggle?id=${product.ID}&isScrapped=${product.IsScrapped}`,
          });
          setProduct(productScrapToggleInner);
          setFormIsDirty(false);
        },
        message: 'Asset scrapped successfully',
        show: true,
        type: 'success'
      });
      setProduct(productScrapToggle);
      setFormIsDirty(false);
    }

    setToggling(false);
  }

  // TRANSFER OF OWNERSHIP

  const [showTransferOfOwnership, setShowTransferOfOwnership] = useState(false);

  const transferOwnership = () => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) return;
    setShowTransferOfOwnership(true);
  };

  const onTransferOfOwnersip = async (transfer: any) => {
    if (transfer) {
      setProduct(transfer.Product);
      setCustomer(transfer.Customer);
      setContact(transfer.Contact);
      setContacts(transfer.Customer.Contacts);
      setLocation(transfer.Location);
      setLocations(transfer.Customer.Locations);

      setFormIsDirty(false);
      setShowTransferOfOwnership(false);

      window.location.reload();
    } else {
      setShowTransferOfOwnership(false);
    }
  };

  const onAttachmentRefresh = () => {
    getCounts(product.ID);
  };

  const [optionButtons] = useState([
    { text: 'New Asset', link: `CreateAsset` },
    { text: 'Transfer Ownership', link: `TransferOwnership`}
  ]);

  const optionsClick = async (link: any) => {
    switch (link) {
      case 'CreateAsset':
        if (formIsDirty) {
          saveProduct('/asset/create');
        } else {
          Helper.nextRouter(Router.push, `/asset/create`);
        }
        break;
      case 'TransferOwnership':
        transferOwnership();
        break;
    }
  };

  const {height: toolbarHeight, ref: toolbarRef} = useElementSize();

  if (!product || !customer) return null;

  return (
    <div>
      <Box bg={'white'} ref={toolbarRef}>
        <Flex justify={'apart'} w={'100%'} mt={'15px'} px={10}>
          <Breadcrumbs currPage={{ text: product.ProductNumber, link: `/asset/${product.ID}`, type: 'asset-show' }} />
          <ToolbarButtons buttonGroups={[
              [{
                type: 'custom',
                children: <WarrantyIndicator purchaseDate={product.PurchaseDate} warrantyPeriod={product.WarrantyPeriod} />
              }],
              [
                {
                  breakpoint: 1100,
                  type: 'menu',
                  disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                  action: optionsClick,
                  text: 'Options',
                  icon: <IconDotsVertical />,
                  legacyOptions: optionButtons,
                }
              ],
              [
                {
                  breakpoint: 850,
                  type: 'button',
                  icon: product.IsScrapped ? <IconSquareCheckFilled color={'var(--mantine-color-green-2)'} /> : <IconSquareCheck color={'var(--mantine-color-green-6)'} />,
                  isBusy: toggling,
                  onClick: toggling ? null : toggleScrapping,
                  variant: product.IsScrapped ? 'filled' : 'outline',
                  color: product.IsScrapped ? 'gray' : 'gray.6',
                  disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                  text: product.IsScrapped ? (toggling ? "Unscrapping Asset" : "Asset Scrapped") : (toggling ? "Scrapping" : "Scrap Asset"),
                },
              ],
            [
              {
                breakpoint: 480,
                type: 'button',
                text: 'Cancel',
                hideIcon: true,
                variant: 'outline',
                icon: <IconArrowBackUp />,
                onClick: cancel,
              }
            ],
            [
              {
                breakpoint: 480,
                type: 'button',
                icon: <IconDeviceFloppy/>,
                isBusy: saving,
                disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                text: saving ? "Saving" : "Save",
                onClick: saving ? null : () => saveProduct(false),
              }
            ]
          ]}
          />
        </Flex>

        <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab}
              tabs={pageTabs}
              useNewTabs
              tabsProps={
                {mt: {base: 'sm', xl: 0}, mx: {base: 1, sm: 'xs', md: 'sm', lg: 'md'}}
              }
        />
      </Box>

      <Box
          bg={'gray.1'}
          py={{base: 5, xs: 8, sm: 'md'}}
          px={{base: 5, xs: 8}}
          mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
      >
        <Card
            p={'md'}
            px={{base: 1, xs: 5, sm: 'sm'}}
            radius={'md'}
        >
          {(() => {
            switch (selectedTab) {
              case 'Asset':
                return <ProductDetails
                    product={product}
                    updateProduct={updateProduct}
                    updateProductInBulk={updateProductInBulk}
                    assetUpdated={(product: any) => {
                      setProduct(product);
                      setFormIsDirty(false);
                    }}
                    markFormAsDirty={(dirty: any) => {
                      setFormIsDirty(dirty);
                    }}
                    triggerSaveComment={triggerSaveComment}
                    formState={assetFormState}
                    setFormState={setAssetFormState}
                    customer={customer}
                    setCustomer={setCustomer}
                    contacts={contacts}
                    setContacts={setContacts}
                    contact={contact}
                    setContact={setContact}
                    locations={locations}
                    setLocations={setLocations}
                    location={location}
                    setLocation={setLocation}
                    customFields={customFields}
                    inputErrors={inputErrors}
                    accessStatus={accessStatus}
                />;
              case 'Attachments':
                return <Attachments displayName={product.ProductNumber} itemId={product.ID} module={Enums.Module.Asset} accessStatus={accessStatus} onRefresh={onAttachmentRefresh} />;
              case 'Messages':
                return <Communications itemId={product.ID} module={Enums.Module.Asset} customerID={customer.ID} selectedContact={contact} accessStatus={accessStatus} />;
              case 'Jobs':
                return <AssetJobsTable productId={product.ID} customerID={customer.ID} module={Enums.Module.Asset} accessStatus={accessStatus} />;
              default:
                return null;
            }
          })()}
        </Card>
      </Box>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      {showTransferOfOwnership ?
        <TransferOwnership sourceCustomer={customer} canChangeCustomer={true} asset={product}
          onTransfer={onTransferOfOwnersip} accessStatus={accessStatus} module={Enums.Module.Asset} />
        : ''
      }

      <style jsx>{`
        .row {
          display: flex;
        }
        .actions {
          display: flex;
          position: relative;
          align-items: center;
        }
        .actions :global(.button) {
          margin-left: 0.5rem;
          margin-top: 0;
          padding: 0 1rem;
          white-space: nowrap;
        }

        .indicator {
            position: absolute;
            margin-left: -2.5rem;
        }
      `}</style>
    </div>
  );
}

export default ProductPage;

export const Route = createFileRoute('/_authenticated/asset/$id')({ component: ProductPage })
